import type { StyleRule } from '@vanilla-extract/css';

export const breakpointsBaseValues = {
  mobile1: 320, // Unused
  mobile2: 375, // Unused
  mobile3: 414,
  mobile4: 568,
  tablet1: 768,
  tablet2: 1024,
  tabletSidebar1: 1006,
  desktop1: 1280,
  desktop2: 1440, // Unused
  desktop3: 1920, // Unused
  desktop4: 1484,

  mobile1Max: 319, // Unused
  mobile2Max: 374, // Unused
  mobile3Max: 413,
  mobile4Max: 567,
  tablet1Max: 767,
  tablet2Max: 1023,
  desktop1Max: 1279,
  desktop2Max: 1439,
  desktop3Max: 1919, // Unused
} as const;

type BreakpointsBase<
  T extends Record<string, number> = typeof breakpointsBaseValues,
> = {
  [K in keyof T]: K extends `${string}Max`
    ? `(max-width: ${T[K]}px)`
    : `(min-width: ${T[K]}px)`;
};

export const breakpointsBase = Object.fromEntries(
  Object.entries(breakpointsBaseValues).map(([k, v]) => {
    return [k, `(${k.includes('Max') ? 'max' : 'min'}-width: ${v}px)`];
  }),
) as BreakpointsBase;

export const makeBreakpoint =
  (condition: string) =>
  (...styles: StyleRule[]): StyleRule => {
    const combinedStyles = styles.reduce((acc, style) => {
      Object.assign(acc, style);
      return acc;
    }, {});
    return {
      '@media': {
        [condition]: combinedStyles,
      },
    };
  };

export const breakpoints = Object.fromEntries(
  Object.entries(breakpointsBase).map(([key, value]) => [
    key,
    makeBreakpoint(value),
  ]),
) as Record<keyof typeof breakpointsBase, (...style: StyleRule[]) => StyleRule>;
